import React from "react";
import { Link } from "react-router-dom";
import { NAV } from "@/constants/testIds";

/**
 * The Intuitus Hub™ logo — uses the client-provided brand mark.
 * Renders the official logo image with a brand-aligned wordmark
 * subtitle. The full-image logo already includes the wordmark, so
 * we simply display it at an appropriate size for each variant.
 */
export const Logo = ({ variant = "dark", size = "default" }) => {
    const sizeClass = size === "large" ? "h-14" : "h-12";
    return (
        <Link
            to="/"
            data-testid={NAV.logo}
            className="inline-flex items-center gap-3 group"
            aria-label="The Intuitus Hub home"
        >
            <img
                src="/intuitus-logo.png"
                alt="The Intuitus Hub"
                className={`${sizeClass} w-auto rounded-md transition-transform group-hover:scale-[1.03]`}
            />
            <span className="hidden sm:flex flex-col leading-tight">
                <span
                    style={{
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: 700,
                        color: variant === "light" ? "#FFFFFF" : "#1A2E4F",
                        fontSize: 15,
                        letterSpacing: "-0.01em",
                    }}
                >
                    The Intuitus Hub
                    <span style={{ color: "#08C020", marginLeft: 2 }}>™</span>
                </span>
                <span
                    style={{
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 500,
                        fontSize: 9.5,
                        letterSpacing: "0.2em",
                        textTransform: "uppercase",
                        color: variant === "light" ? "rgba(255,255,255,0.65)" : "#4A5568",
                        marginTop: 3,
                    }}
                >
                    Human + AI Consulting
                </span>
            </span>
        </Link>
    );
};

export default Logo;
